export default __webpack_public_path__ + "static/backupandRecovery-b36db1f2aafba9735cad63f1fc7f230e.svg";